var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRightCaretAlternate = function SvgRightCaretAlternate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.941 4.178a1 1 0 010 1.644L2.197 9.11a1 1 0 01-1.57-.822V1.713a1 1 0 011.57-.822l4.744 3.287z",
    fill: "#5F6771"
  })));
};
export default SvgRightCaretAlternate;